import { Location } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
/*
 * L2-R6: moved from `src/app/shared/components/go-back-link/go-back-link.component.ts`.
 * Inline template, Location + Router only. The old host path is a re-export shim.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line
  selector: '[miq-go-back-link]',
  template: `
    <span (click)="back()">@if (!hideIcon()) {
      <mat-icon>arrow_back</mat-icon>
      } <ng-content></ng-content></span>
    `,
  imports: [MatIcon],
})
export class GoBackLinkComponent {
  withRoute = input<string[]>();
  hideIcon = input(false);
  private readonly location = inject(Location);
  private readonly router = inject(Router);
  back() {
    !this.withRoute() ? this.location.back() : this.router.navigate(this.withRoute());
  }
}
